export const HEADING_FONT = `BiankaScript, cursive;`;
export const HEADING_ALTERNATIVE = `'Pinyon Script', cursive;`;
export const BODY_FONT = `"Cormorant Upright", serif;`;
export const BODY_ALTERNATIVE = BODY_FONT;

